import React from "react";

import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import { Alert } from "hooks/use-alert-bar.hook";

import CustomAlert from "./custom-alert.component";

type AlertBarProps = {
  alerts: Alert[];
  removeAlert: (id: number | string) => void;
};
export default function AlertBar({ alerts, removeAlert }: AlertBarProps) {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Stack spacing={1}>
          {alerts.map((alert) => (
            <CustomAlert key={alert.id} alert={alert} onClose={removeAlert} />
          ))}
        </Stack>
      </Grid>
    </Grid>
  );
}
